import { createSelector } from 'reselect';
import { getLocaleMeasurementUnits } from '@commutifi-fe/utils';
import { RootState } from '../../reducer';
export const getLocale = ({
  localSettings
}: RootState) => localSettings.locale;
export const getLocaleUnits = createSelector([getLocale], locale => getLocaleMeasurementUnits(locale));